<template>
  <v-container fluid id="header" class="elevation-2">
    <v-layout row align-center class="text-xs-center" style="padding: 0 26px;">
      <v-flex
        v-if="$route.name == 'Course'"
        shrink
        style="padding-right: 4px;"
        class="text-xs-left"
      >
        <v-btn
        class="btn-nav btn-back"
        style="color:  #21699B; "

        @click="dialog=true"
        >
          <v-icon v-text="'$vuetify.icons.back'"></v-icon>
          <span v-show="$vuetify.breakpoint.mdAndUp" style="margin-right: 7px;">Zurück</span>
        </v-btn>
      </v-flex>
      <v-dialog
        v-model="dialog"
        max-width="400"
      >
        <v-card>
          <v-card-title class="headline">Schulung wirklich unterbrechen?</v-card-title>

          <v-card-text>
            Möchten Sie die Schulung wirklich unterbrechen?
          </v-card-text>

          <v-card-actions>
            <v-layout :column="$vuetify.breakpoint.xs" row wrap>
              <v-flex>
                <v-btn
                  color="green white--text"
                  @click="dialog = false"
                >
                  Weitermachen
                </v-btn>
              </v-flex>
              <v-flex :style="{paddingTop: $vuetify.breakpoint.xs ? '7px': '0px'}">
                <v-btn
                  color="red  white--text"
                  @click="dialog=false, $router.push({ name: 'Dashboard', params: { clientId: $route.params.clientId ? $route.params.clientId : undefined } })"
                >
                  Schulung Unterbrechen
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
    </v-dialog>


      <v-flex 
        grow
        class="text-xs-left"
        >
        
        <div
          style=" 
                height: 100%; 
                font-size: 1.2rem; 
                font-weight: 600;"
                
          ><img 
              height="30" 
              src="../../public/img/vde-service-logo.png"
              style="vertical-align: bottom;"
          />
          &nbsp;Datenschutzschulungen
        </div>
      </v-flex>

      <!-- <v-flex shrink v-if="$store.state.user.isAdmin">
        <v-tooltip bottom open-delay="600">
          <template v-slot:activator="{on}">
            <v-btn 
              icon
              style="color:  #21699B;"
              v-on="on"
              @click="visibleAdminDialog = true"
            >
              <v-icon>
                {{$vuetify.icons.usersCog}}
              </v-icon>
            </v-btn>
          </template>
        </v-tooltip>
      </v-flex> -->

      <v-flex shrink v-if="$store.state.authenticated && $route.name == 'Dashboard' && $store.state.user.isSuperAdmin">
        <v-tooltip bottom open-delay="600">
          <template v-slot:activator="{ on }">
              <v-btn
              style="color:  #FF0000; font-weight: bold;"
                v-on="on"

                @click="$router.push('/superadmin')"
              >SuperAdmin</v-btn>
          </template>
          <span>SuperAdmin</span>
        </v-tooltip>
        
      </v-flex>
      <v-flex shrink v-if="$store.state.authenticated && $route.name == 'Superadmin' && $store.state.user.isSuperAdmin">
        <v-tooltip bottom open-delay="600">
          <template v-slot:activator="{ on }">
              <v-btn
              style="color:  #FF0000; font-weight: bold;"
                v-on="on"

                @click="$router.push('/dashboard')"
              >zum Dashboard</v-btn>
          </template>
          <span>zurück zum Dashboard</span>
        </v-tooltip>
        
      </v-flex>


      <v-flex shrink v-if="$store.state.authenticated && $route.name == 'Dashboard' && $store.state.userRole.role === 'DSB'">
        <v-tooltip bottom open-delay="600">
          <template v-slot:activator="{ on }">
              <v-btn
              style="color:  #21699B;"
                v-on="on"
                icon
                @click="showClientsDialog"
              ><v-icon>{{$vuetify.icons.building}}</v-icon></v-btn>
          </template>
          <span>Unternehmen verwalten als DSB</span>
        </v-tooltip>
        
      </v-flex>
      
      <v-flex shrink v-if="$store.state.authenticated && $route.name == 'Dashboard'">
        <!-- TODO: Auskommentiert wie in #18 beschrieben -->
        <v-btn style="color:  #21699B;" icon v-if="!hasOnlyRoleDST  && receiversLength > 0" @click="setVisibleMsgWindow(true)">
          <v-badge color="red" left>
              <template v-slot:badge>
                  <span v-if="messageCounts.unread > 0">{{messageCounts.unread}}</span>
              </template>
              <v-tooltip bottom open-delay="600">
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mail</v-icon>
                </template>
                <span>Messenger mit Nachrichten für {{currentClient.clientName}}</span>
              </v-tooltip>
          </v-badge>
        </v-btn>
        <v-btn icon v-if="hasOnlyRoleDST && messageCounts.sum > 0" @click="setVisibleMsgWindow(true)">
          <v-badge color="red" left>
              <template v-slot:badge>
                  <span v-if="messageCounts.unread != 0">{{messageCounts.unread}}</span>
              </template>
              <v-tooltip bottom open-delay="600">
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mail</v-icon>
                </template>
                <span>Messenger mit Nachrichten für {{currentClient.clientName}}</span>
              </v-tooltip>
              
          </v-badge>
        </v-btn>
      </v-flex>
      <v-flex shrink v-if="currentClient !== {} && $route.name == 'Dashboard'">
        <template v-if="clientRoles.length > 1">
          <v-select
            style="width: 250px;"
            label="Unternehmen | Rolle"
            :items="clientRoles"
            :value="currentClient"
            item-text="client"
            item-value="client"
            @input="setCurrentClient($event)"
          >
            <template v-slot:selection="{ item, index }">
              <span style="color:  #21699B;max-width: 230px; overflow-x: hidden; white-space: nowrap;">{{item.text}}</span>
            </template>
            <template v-slot:item="{ item, index }">
              <span style="">{{item.text}}</span>
            </template>
          </v-select>
        </template>
        <!-- <template v-if="$store.state.clients.length > 1">
          <v-select
            style="padding-right: 12px;"
            dark
            label="Unternehmen"
            :items="$store.state.clients"
            :value="currentClient.clientId"
            item-text="name"
            item-value="clientId"
            @input="setCurrentClient($event)"
          >
            <template v-slot:selection="{ item, index }">
              {{item.name}}
            </template>
            <template v-slot:item="{ item, index }">
              {{item.name}}
            </template>
          </v-select>
        </template>
        <template v-else>
          {{currentClient.name}}
        </template> -->
      </v-flex>
      <v-flex
        shrink
        v-if="$store.state.authenticated && $route.name == 'Dashboard' && $store.state.userRole.role === 'DST' && clientRoles.length == 1">
        <v-text-field
          style="width: 250px; color:  #21699B;"
          disabled
          :value="$store.state.userRole.text"
          label="Unternehmen | Rolle"
        >
        </v-text-field>
      </v-flex>
      <v-flex
        shrink 
        class="text-xs-center"
        v-if="$store.state.authenticated && $route.name == 'Dashboard'"
      >
          <v-tooltip bottom open-delay="600">
            <template v-slot:activator="{ on }">
                <v-btn style="color:  #21699B;" v-on="on" icon @click="fetchDataUser()">
                  <v-icon>$vuetify.icons.user</v-icon>
                </v-btn>
            </template>
            <span>Meine persönlichen Daten ändern</span>
          </v-tooltip>
      </v-flex>
      <!-- <v-flex
        v-if="clientRoles.length > 1 && $store.state.authenticated && $route.name == 'Dashboard'"
        xs2
        md2
        >
        <v-select
          id="role-selection"
          dark
          :items="clientRoles"
          :value="$store.state.userRole"
          @change="changeRole"
          label="Rolle"
        ></v-select>
      </v-flex> -->
      
      <!-- <v-flex class="text-xs-right" :class="{'offset-xs2': $store.state.userRole.role == 'DST' && clientRoles.length == 1 && $store.state.authenticated && $route.name == 'Dashboard'}"> -->
      <v-flex shrink class="text-xs-center">
       <v-tooltip bottom open-delay="600">
          <template v-slot:activator="{ on }">
            <v-btn style="color:  #21699B;" icon v-on="on">
              <a style="color: inherit; text-decoration: none;" target="_blank" href="https://wst.vde-service.de/wst/help">
                <v-icon>far fa-question-circle</v-icon>
              </a>
            </v-btn>
          </template>
          <span>Zur Hilfe-Seite</span>
        </v-tooltip>
        
      </v-flex>
      <v-flex shrink class="text-xs-right">
        <v-btn
        style="color:  #21699B;"
        class="btn-nav btn-back" @click="performLogout()"
        v-if="$store.state.authenticated && $route.name == 'Dashboard'"
          >
          <v-icon v-text="'$vuetify.icons.signOut'"></v-icon>
          <span v-show="$vuetify.breakpoint.mdAndUp" style="margin-left: 7px;">Logout</span>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="visibleUserEditDialog"
      width="600"
    >
      <v-card 
      style="min-height: 500px;">
        <v-layout column>
          <v-flex shrink>
            <v-layout row align-center style="padding: 0 14px;">
              <v-flex shrink>
                <span style="padding: 4px;">
                  <h3>Persönliche Daten ändern</h3>
                </span>
                
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink>
                <v-btn icon @click="visibleUserEditDialog = false">
                  <v-icon style="color: black">fas fa-times</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex grow style="padding: 16px;">
            <v-form ref="userForm">
              <v-layout column>
                <v-flex>
                  <v-select
                    v-model="editUser.salutation"
                    :items="salutations"
                    :label="userKeyMap['salutation']"
                    :rules="[rules.required]"
                  ></v-select>
                </v-flex>
                <v-flex>
                  <v-select
                    clearable
                    v-model="editUser.title"
                    :items="titels"
                    :label="userKeyMap['title']"
                    @click:clear="editUser.title = ''"
                  ></v-select>
                </v-flex>
                <!-- <v-flex>
                  <v-select
                    :label="userKeyMap['salutation']"
                    :items="salutations"
                    :value="editUser['salutation']"
                    @change="changeEditUser('salutation', $event)"
                    :rules="[rules.required]"
                  ></v-select>
                </v-flex> -->
                <v-flex>
                  <v-text-field
                    :label="userKeyMap['firstname']"
                    :value="editUser['firstname']"
                    @input="changeEditUser('firstname', $event)"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    :label="userKeyMap['lastname']"
                    :value="editUser['lastname']"
                    @input="changeEditUser('lastname', $event)"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    :label="userKeyMap['newEmail']"
                    :value="editUser['newEmail']"
                    @input="changeEditUser('newEmail', $event)"
                    :rules="[rules.required, rules.email]"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
          <v-flex>
            <v-expand-transition>
              <v-form v-show="showEmailTokenField" ref="emailToken">
                
                  <v-layout column style="padding: 16px;">
                    <v-flex>
                      Bei Änderung der E-Mail, muss diese erst geprüft werden. Sie erhalten eine E-Mail, in der Ihr Bestätigungs-Code enthalten ist.
                    </v-flex>
                    <v-expand-transition>
                      <v-flex v-show="showEmailTokenField">
                        <v-text-field
                          :value="emailToken"
                          @input="setToken($event)"
                          :rules="[rules.required, rules.minLength]"
                          label="Bestästigungs-Code"
                        ></v-text-field>
                      </v-flex>
                      
                    </v-expand-transition>
                  </v-layout>
              </v-form>
            </v-expand-transition>
          </v-flex>
          <v-flex grow v-if="errorMsg.length > 0">
              <div style="padding: 16px;">
                  <v-layout column>
                      <v-flex>
                          <v-alert
                              :value="errorMsg.length > 0"
                              type="error"
                              outline
                          >
                              Fehler: {{errorMsg}}
                          </v-alert>
                      </v-flex>
                  </v-layout>
              </div>
          </v-flex>
          <v-flex shrink>
            <v-layout row>
              <v-spacer></v-spacer>
              
              <v-flex shrink>
                <v-layout row>
                  <v-flex v-if="!showEmailTokenField">
                    <v-btn @click="updateUser()">
                      Speichern
                    </v-btn>
                  </v-flex>
                  <v-flex v-else>
                    <v-btn @click="updateUser()" >
                      Bestätigen
                    </v-btn>
                  </v-flex>
                </v-layout>
                
                
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="visibleAdminDialog"
        width="1000"
    >
      <v-card style="padding: 0" v-if="$store.state.authenticated && $store.state.user.isAdmin">
        <v-layout column style="padding: 0">
        
          <v-flex>
            <v-layout row style="padding: 0;">
              <v-spacer></v-spacer>
              <v-flex shrink>
                <v-btn icon @click="visibleAdminDialog = false">
                  <v-icon>fas fa-times</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex>
            <admin></admin>
          </v-flex>
        </v-layout>
      </v-card>
        
    </v-dialog>

    <communication-window
      :visible="visibleMsgWindow"
      @close="closeMsgWindow"
      @send="log($event)"
      @select="log($event)"
    ></communication-window>
    <!-- <msg-window
      :visible="visibleMsgWindow"
      :receivers="receivers"
      :messages="messages"
      :counts="messageCounts"
      @readMessagesFrom="readMessageFrom"
      @close="visibleMsgWindow = false"
      @send="sendMessage"
    ></msg-window> -->
  </v-container>
</template>

<script>
import MsgWindow from '@/components/MsgWindow'
import CommunicationVue from '../components/Communication.vue'
import AdminVue from '../components/Admin.vue'

  export default {
    //props: ["roles"],
    components: {
        'msg-window': MsgWindow,
        'communication-window': CommunicationVue,
        'admin': AdminVue
    },
    data() {
      return {
        dialog: false,
        visibleMsgWindow: false,
        receiversLength: 0,
        
        messageCounts: {
          unread: 0,
          sum: 0
        },
        editUser: {
          email: '',
          newEmail: '',
          salutation: '',
          firstname: '',
          lastname: '',
          title: ''
        },

        salutations: ["Herr", "Frau"],
        titels: ["Dr.", "Prof.", "Dr. Dr.", "Prof. Dr."],

        errorMsg: '',

        userKeyMap: {
          newEmail: 'E-Mail',
          salutation: 'Anrede',
          title: 'Titel',
          firstname: 'Vorname',
          lastname: 'Nachname'
        },

        salutations: ['Herr', 'Frau'],

        rules: {
            required: value => !!value || 'Erforderlich',
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Ungültige E-Mail-Adresse'
            },
            minLength: value => (value + '').trim().length === 6 || 'Der Bestätigungs-Code muss aus 6 Zeichen bestehen'
        },

        visibleUserEditDialog: false,
        showEmailTokenField: false,
        validToken: false,
        emailToken: '',

        visibleAdminDialog: false
      }
    },
    watch: {
      visibleUserEditDialog(value) {
        this.showEmailTokenField = false;
        this.validToken = false;
        this.emailToken = '';
        this.$refs.userForm.reset();
        this.$refs.emailToken.reset();
      }
    },
    computed: {
      hasOnlyRoleDST() {
        let roles = [];
        this.$store.state.clients.map(client => client.roles).forEach(userRoles => {
          if(!roles.includes(...userRoles)) roles.push(...userRoles.filter(role => !roles.includes(role)));
        },this);
        return roles.length == 1 && roles[0] == 'DST'


      },
      currentClient() {
        let userRole = this.$store.state.userRole;
        return userRole ? userRole : {}
      },
      clientRoles() {
        const clients = JSON.parse(JSON.stringify(this.$store.state.clients));

        let preparedClients = [];

        for(let client of clients) {
          for(let role of client.roles) {
            preparedClients.push({
              text: client.clientName + ' | ' + role,
              role,
              clientName: client.clientName,
              clientId: client.clientId
            });
          }
        }

        return preparedClients;
      }
    },
    mounted() {
      let self = this;
      EventBus.$on('authenticated', () => {
        this.fetchReceivers(this.currentClient.role, this.currentClient.clientId);
        this.fetchMessageCounts(this.currentClient.role, this.currentClient.clientId);
      });
      
    },
    methods: {
      log() {
        console.log(...arguments)
      },
      changeEditUser(key, value) {
        // if(key == 'newEmail') {
        //   console.log(value !== this.editUser.email)
        //   this.needEmailToken = value !== this.editUser.email;
        // }
        this.editUser[key] = value;
      },
      setToken(token) {
        this.errorMsg = '';
        this.emailToken = token;
        this.validateToken(token);
      },
      validateToken(token) {
        this.validToken = token && (token + '').trim().length === 6;
      },
      closeMsgWindow() {
        this.showEmailTokenField = false,
        this.visibleMsgWindow = false;
        this.fetchMessageCounts(this.$store.state.userRole.role, this.$store.state.userRole.clientId);
      },
      showUserEditDialog() {
        this.visibleUserEditDialog = true;
      },
      fetchDataUser() {
        let self = this;

        this.setErrorMsg({error: ''});
        this.showUserEditDialog();

        this.axios.axiosCall({
          url: actionUrl + "rest/user/info",
          data: {},
          blockGui: false,
          success: (response) => {
            self.setUser(response.data)
          }
        })
      },
      setUser(user) {
        this.$store.commit('setUser', user)
        this.editUser = user;
        this.editUser.newEmail = user.email;
        //this.visibleUserEditDialog = false;
      },
      checkEmail() {
        let self = this;
        this.axios.axiosCall({
          url: actionUrl + "rest/user/check-email",
          data: {
            newEmail: this.editUser.newEmail,
            clientId: this.$store.state.currentClient.clientId
          },
          blockGui: false,
          success: (response) => {
            if(response.data.success) {
              self.showEmailTokenField = true;
            } else if(response.data.error) {
              self.setErrorMsg(response.data)
            }
          }
        })
        
      },
      updateUser() {
        if(this.$refs.userForm.validate()) {
        
          this.errorMsg = '';
          let valid = false;

          const emailChanged = this.editUser.newEmail !== this.editUser.email;

          if(emailChanged && !this.showEmailTokenField) {
            this.checkEmail()
          } else {
            let data = this.editUser;

            if(this.showEmailTokenField) {
              data.token = this.emailToken.trim();
            }

            let self = this;

            this.axios.axiosCall({
              url: actionUrl + "rest/user",
              data,
              blockGui: false,
              success: (response) => {
                if(response.data.success) {
                  self.visibleUserEditDialog = false
                  self.showEmailTokenField = false;
                  EventBus.$emit('showSnackbar', 'Änderungen erfolgreich gespeichert')
                  self.fetchDataUser()
                } else if(response.data.error) {
                  self.setErrorMsg(response.data)
                }
                self.emailToken = '';
              }
            })
          }

          //   if(this.needEmailToken && this.validToken) {
          //     valid = true;
          //   } else if(!this.needEmailToken) {
          //     valid = true;
          //   }
          // }
        }
      },
      setErrorMsg({error}) {
        if(error.includes('email already exists')) this.errorMsg = 'Die von Ihnen gewählte E-Mail wird bereits benutzt.'
        else if(error.includes('user could not be updated')) this.errorMsg = 'Die Daten konnten nicht gespeichert werden.'
        else if(error.includes('invalid token')) this.errorMsg = 'Der Bestätigungs-Code existiert nicht oder wurde fehlerhaft eingegeben.'
        else if(error.includes('email with token could not be send')) this.errorMsg = 'Die E-Mail mit dem Bestätigungs-Code konnte nicht versandt werden.'
        else this.errorMsg = '';
      },
      showClientsDialog() {
        EventBus.$emit('showDatatableClients');
      },
      setCurrentClient(client) {
        console.log(client.role, client.clientId)
        EventBus.$emit('changeClient');

        this.changeRole(client);

        const clients = JSON.parse(JSON.stringify(this.$store.state.clients)); 
        this.$store.commit('setCurrentClient', clients.filter(clientObj => clientObj.clientId == client.clientId)[0])
      },
      fetchMessageCounts(role, clientId) {
        let self = this;

        this.axios.axiosCall({
          url: actionUrl + "rest/messages/counts",
          method: 'POST',
          data: {
            userRole: role,
            clientId: clientId
          },
          success: function(response) {
            self.messageCounts = response.data;
          }
        })
      },
      setVisibleMsgWindow(value) {
        //this.fetchMessages();
        this.fetchMessageCounts(this.$store.state.userRole.role, this.$store.state.userRole.clientId);
        this.visibleMsgWindow = !this.visibleMsgWindow;
      },
      updateLocation(clientId) {
        this.$router.push({name: this.$route.name, params: { clientId, clientId}})
      },
      changeRole(role) {
        this.$store.commit("setUserRole", role);
        this.updateLocation(this.$store.state.userRole.clientId);
        this.fetchMessageCounts(role.role, this.$store.state.userRole.clientId);
        this.fetchReceivers(role.role, this.$store.state.userRole.clientId);

        let el = document.querySelector( ':focus' );
        if( el ) el.blur();
      },
      fetchReceivers(role, clientId) {
        let self = this;
        this.axios.axiosCall({
        url: actionUrl + "rest/messages/receivers",
        method: 'POST',
        data: {
            userRole: role,
            clientId: clientId
        },
        blockGui: false,
        success: function(response) {
            self.receiversLength = response.data.receivers.length;
        }
    })
      },
      performLogout() {
        let self = this;

        window.location.href = location.protocol + '//' + location.host + '/wst/#/login';

        this.axios.axiosCall({
          url: actionUrl + "rest/auth/logout",
          blockGui: false,
          success: function(response) {
            self.$router.push({ name: 'Login', params: { clientId: self.$route.params.clientId ? self.$route.params.clientId : undefined } })
          }
        });
      }
    }
  }
</script>

<style>
#header .v-input .v-label, 
#header .v-input .v-icon {
  color:  #21699B !important;
}

#header .v-text-field > .v-input__control > .v-input__slot:after {
  border-color: white;
}
</style>

<style scoped>
.btn-nav.btn-back {
  padding: 0;
  min-width: 38px;
}

#header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10000001;
}
.container {
  padding-top: 0;
  padding-bottom: 0;
  max-height: 60px;

  border-bottom: 2px solid #002a9c;

  color:  #21699B;
  /* background-color:  #21699B; */
  background-color: white;
}

.layout {
  height: 100%;
}

#logo{
  height: auto;
  width: 50%;
  margin: 10px 7px 10px 0;
  max-width: 150px;
  display: inline-block;
}

.v-icon.fas {
  padding: 7px;
  font-size: 1.4rem;
}
</style>
